import { createSlice } from '@reduxjs/toolkit';

// The domiciliary-schedule draft queue. Mirrors the duty-roster model: every
// schedule edit (assign/unassign, time away, remove time away, extra
// availability, stop visit) is appended here as a "change" instead of hitting
// the API. The board renders the server snapshot with this queue applied on
// top (see applyScheduleDraft), and Publish replays the queue against the API.
//
// A change looks like:
//   { id, type, payload, label, dedupKey? }
// where `type` is one of:
//   assign | timeAway | removeTimeAway | availability | stopVisit
const initialState = {
  changes: [],
};

const domiciliaryScheduleDraftSlice = createSlice({
  name: 'domiciliaryScheduleDraft',
  initialState,
  reducers: {
    // Append a change. If it carries a dedupKey matching an existing queued
    // change, the new one replaces it (e.g. re-assigning the same visit keeps a
    // single entry).
    enqueueChange(state, action) {
      const change = action.payload;
      if (change.dedupKey) {
        const idx = state.changes.findIndex((c) => c.dedupKey === change.dedupKey);
        if (idx >= 0) { state.changes[idx] = change; return; }
      }
      state.changes.push(change);
    },
    removeChange(state, action) {
      state.changes = state.changes.filter((c) => c.id !== action.payload);
    },
    // Replace the whole queue (used after a partial publish to keep only the
    // changes that failed to sync).
    setChanges(state, action) {
      state.changes = action.payload;
    },
    clearChanges(state) {
      state.changes = [];
    },
  },
});

export const { enqueueChange, removeChange, setChanges, clearChanges } = domiciliaryScheduleDraftSlice.actions;
export default domiciliaryScheduleDraftSlice.reducer;
